import axios from '../index'

export function getContentTypes(params) {
  return axios.get('/ajax/clients/ai_content/content_types', { params })
}

export function getContentTypesForSelect(params) {
  return axios.get('/ajax/clients/ai_content/content_types/index_for_select', { params })
}

export function createContentType(params) {
  return axios.post('/ajax/clients/ai_content/content_types', params)
}

export function updateContentType(id, params) {
  return axios.put(`/ajax/clients/ai_content/content_types/${id}`, params)
}

export function deleteContentType(id) {
  return axios.delete(`/ajax/clients/ai_content/content_types/${id}`)
}
